
export class EventData  {
    constructor(name,data){
        this.name = name;
        this.data = data;
    }
    name: string;
    data: any;
}